import React from 'react';

const WhatsappIcon = ({
  showNewUI = false,
  fillColor = '#85dd62',
  size = '40',
}) =>
  showNewUI ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 18 18"
      fill="none">
      <path
        d="M4.75002 16.1666C6.00002 16.9166 7.50002 17.3333 9.00002 17.3333C13.5834 17.3333 17.3334 13.5833 17.3334 8.99996C17.3334 4.41663 13.5834 0.666626 9.00002 0.666626C4.41669 0.666626 0.666687 4.41663 0.666687 8.99996C0.666687 10.5 1.08335 11.9166 1.75002 13.1666L1.10713 15.6393C0.912406 16.3882 1.60561 17.065 2.34967 16.8524L4.75002 16.1666Z"
        stroke={fillColor}
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.75 11.3737C12.75 11.5087 12.72 11.6475 12.6561 11.7825C12.5923 11.9175 12.5097 12.045 12.4007 12.165C12.2167 12.3675 12.0139 12.5138 11.7848 12.6075C11.5595 12.7013 11.3154 12.75 11.0525 12.75C10.6694 12.75 10.26 12.66 9.82813 12.4763C9.39623 12.2925 8.96434 12.045 8.53619 11.7338C8.1043 11.4188 7.69493 11.07 7.30435 10.6837C6.91752 10.2937 6.56824 9.885 6.25652 9.4575C5.94856 9.03 5.70069 8.6025 5.52042 8.17875C5.34015 7.75125 5.25002 7.3425 5.25002 6.9525C5.25002 6.6975 5.29508 6.45375 5.38522 6.22875C5.47535 6 5.61807 5.79 5.81712 5.6025C6.05748 5.36625 6.32037 5.25 6.59829 5.25C6.70345 5.25 6.8086 5.2725 6.90249 5.3175C7.00014 5.3625 7.08652 5.43 7.15412 5.5275L8.02543 6.75375C8.09303 6.8475 8.14185 6.93375 8.17565 7.01625C8.20945 7.095 8.22823 7.17375 8.22823 7.245C8.22823 7.335 8.20194 7.425 8.14936 7.51125C8.10054 7.5975 8.02918 7.6875 7.93905 7.7775L7.65362 8.07375C7.61231 8.115 7.59353 8.16375 7.59353 8.22375C7.59353 8.25375 7.59729 8.28 7.6048 8.31C7.61606 8.34 7.62733 8.3625 7.63484 8.385C7.70244 8.50875 7.81887 8.67 7.98412 8.865C8.15312 9.06 8.33339 9.25875 8.52868 9.4575C8.73149 9.65625 8.92678 9.84 9.12583 10.0087C9.32112 10.1737 9.48261 10.2862 9.61031 10.3537C9.62908 10.3612 9.65162 10.3725 9.67791 10.3837C9.70795 10.395 9.738 10.3987 9.7718 10.3987C9.83564 10.3987 9.88447 10.3763 9.92578 10.335L10.2112 10.0538C10.3051 9.96 10.3952 9.88875 10.4816 9.84375C10.568 9.79125 10.6544 9.765 10.7483 9.765C10.8196 9.765 10.8947 9.78 10.9774 9.81375C11.06 9.8475 11.1464 9.89625 11.2403 9.96L12.4834 10.8412C12.581 10.9087 12.6486 10.9875 12.6899 11.0812C12.7275 11.175 12.75 11.2687 12.75 11.3737Z"
        stroke={fillColor}
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
    </svg>
  ) : (
    <svg
      id="Whatsapp"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 72 72">
      <circle
        id="Ellipse_705"
        data-name="Ellipse 705"
        cx="36"
        cy="36"
        r="36"
        fill="rgba(41,97,250,0)"
      />
      <g id="WA_Logo" data-name="WA Logo" transform="translate(18.055 17.615)">
        <path
          id="Path_65753"
          data-name="Path 65753"
          d="M102.748,5.226a18.032,18.032,0,0,0-23.4-1.5A17.29,17.29,0,0,0,74.74,26.311l-2.52,9.061,9.462-2.456a18.033,18.033,0,0,0,8.5,2.132h0A17.8,17.8,0,0,0,106.6,24.265a17.266,17.266,0,0,0-3.82-19.039ZM90.162,32.113h0a14.956,14.956,0,0,1-7.553-2.024l-.522-.364-5.6,1.484,1.5-5.357-.371-.547A14.347,14.347,0,0,1,79.388,7.582,14.989,14.989,0,0,1,97.3,4.837a14.444,14.444,0,0,1,7.179,16.352,14.753,14.753,0,0,1-14.32,10.917Zm8.109-10.876c-.446-.223-2.63-1.275-3.042-1.424s-.687-.216-1,.216-1.154,1.424-1.373,1.707-.522.331-.961.108A12.228,12.228,0,0,1,88.322,19.7a13.242,13.242,0,0,1-2.52-3.023c-.261-.439,0-.675.192-.9s.446-.506.687-.762a3.045,3.045,0,0,0,.439-.729.8.8,0,0,0,0-.769c-.11-.216-1-2.368-1.373-3.239s-.769-.729-1.044-.756a8.291,8.291,0,0,0-.838-.04,1.653,1.653,0,0,0-1.188.547,4.864,4.864,0,0,0-1.559,3.65,8.359,8.359,0,0,0,1.82,4.514A19.73,19.73,0,0,0,90.533,24.8a23.184,23.184,0,0,0,2.534.918,6.243,6.243,0,0,0,2.8.175,4.592,4.592,0,0,0,2.98-2.078,3.6,3.6,0,0,0,.254-2.078c-.1-.189-.385-.283-.831-.5Z"
          transform="translate(-72.22 -0.116)"
          fill={fillColor}
        />
      </g>
    </svg>
  );

export default WhatsappIcon;
